import axios from "../axios-defaults";

const RECOMMENDATION_API_BASE_URL =
  process.env.REACT_APP_RECOMMENDATION_API_ENDPOINT ||
  "https://dev-recommendation-api.scoutproportal.com";

const sendAiChat = (payload) => {
  return axios.post(`${RECOMMENDATION_API_BASE_URL}/api/v1/ai-chat`, payload);
};

const analyzeInspection = (id) => {
  return axios.get(`${RECOMMENDATION_API_BASE_URL}/api/v1/analysis/${id}`);
};

export { sendAiChat, analyzeInspection };
